import { css } from '@emotion/react';

/**
 *  flex style
 * @param {string} display inline-flex or flex (default: flex)
 * @param {string} justifyContent 태그 배치 종류
 * @param {string} alignItems 수직 정렬
 *  */
export const flexFrame = (display: string, justifyContent: string, alignItems: string) => css`
  display: ${display || 'flex'};
  justify-content: ${justifyContent};
  align-items: ${alignItems};
`;
